<form  nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="subject" nzRequired #label>Tiêu đề</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="subject" name="subject" type="text" placeholder="Nhập tiêu đề">
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="listTo" nzRequired #label>Người nhận</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <nz-select 
            nzMode="multiple" 
            nzPlaceHolder="Chọn người nhận" 
            name="listTo" 
            [nzMaxTagCount]="3" 
            [nzMaxTagPlaceholder]="tagPlaceHolder" 
            formControlName="listTo"
            >
            <nz-option *ngFor="let option of listCC" [nzLabel]="option.value" [nzValue]="option.id">
            </nz-option>
          </nz-select>
          <button nz-button nzType="primary" class="button-select" (click)="openSelectListTo()">
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </button>
          <ng-template #tagPlaceHolder let-selectedList> và hơn {{ selectedList.length }} người khác </ng-template>
        </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="listCc">Cc</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzMode="multiple" nzPlaceHolder="Cc" name="listCc" formControlName="listCc" [nzMaxTagCount]="3" [nzMaxTagPlaceholder]="tagPlaceHolderCC">
            <nz-option *ngFor="let option of listCC" [nzLabel]="option.value" [nzValue]="option.id">
            </nz-option>
          </nz-select>
          <button nz-button nzType="primary" class="button-select" (click)="openSelectListCc()">
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </button>
          <ng-template #tagPlaceHolderCC let-selectedList> và hơn {{ selectedList.length }} người khác </ng-template>
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="listAttachment">Đính kèm</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload" [nzRemove]="hanldeRemove" [nzShowUploadList]="{ showRemoveIcon: true, showDownloadIcon : false }">
            <button nz-button><i nz-icon nzType="upload"></i>Chọn File</button>
          </nz-upload>
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="body">Nội dung</nz-form-label>
        <nz-form-control nzSpan="24">
          <editor
            formControlName="body"
            apiKey="m4incqi12031wyw9523nezwwksx8zg0mnvni6mnu03iovjeh"
            [init]="{
              language: 'vi',
              language_url : 'assets/tinymce_languages/vi.js',
              height: 300,
              menubar: 'file edit format table help',
              plugins: [
                'advlist autolink lists link image charmap print',
                'preview anchor searchreplace visualblocks code',
                'fullscreen insertdatetime media table paste',
                'help wordcount'
              ],
              toolbar:
                'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment'
            }"
          >
          </editor>
        </nz-form-control>
      </nz-form-item >
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close($event)">Đóng</button>
    <button nz-button (click)="hanlderSaveMail()" [nzSize]="'large'" nzType="primary">
      Lưu
      <i nz-icon nzType="radius-upleft"></i>
    </button>
    <button nz-button (click)="hanlderSendMail()" [nzSize]="'large'" nzType="primary">
      Gửi thư
      <i nz-icon nzType="send" nzTheme="outline"></i>
    </button>
  </div>
</form>